import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { LoginComponent } from 'src/app/modules/auth/login/login.component';
import {DomSanitizer} from "@angular/platform-browser";
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-public-home',
  templateUrl: './public-home.component.html',
  styleUrls: ['./public-home.component.scss']
})
export class PublicHomeComponent implements OnInit {

  breakpoint: number;
  pdfURL : any;
  constructor(public dialog: MatDialog,private domSanitizer : DomSanitizer,
    private authService : AuthService,private router: Router) { }

  ngOnInit() {
    this.breakpoint = (window.innerWidth <= 400) ? 1 : 6;
    //this.pdfURL = this.domSanitizer.bypassSecurityTrustResourceUrl('https://www.drbeen.com/');
    if(this.authService.isAuthenticated()){
      this.router.navigate(['home']);
    }
    
}

onResize(event) {
  this.breakpoint = (event.target.innerWidth <= 400) ? 1 : 6;
}


  openLogin() : void{
    let dialogRef = this.dialog.open(LoginComponent, {
      width: '250px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });

  }



}
